<template>
  <div class="max-w-7xl mx-auto py-3 md:py-6 sm:px-8 lg:pt-8">
    <header-component :title="$t('customization.customization')"></header-component>

    <section-navigation-component :sections="sections" aria-label="customization.sections" class="mt-4 px-4 lg:px-8">
      <router-view></router-view>
    </section-navigation-component>
  </div>
</template>

<script>
import HeaderComponent from "@/views/common/HeaderComponent";
import SectionNavigationComponent from "@/components/navigation/SectionNavigationComponent";

export default {
  name: "AcademyComponent",
  components: {
    HeaderComponent,
    SectionNavigationComponent,
  },
  data() {
    return {
      sections: [
        { key: 'identity', to: { name: 'academy.identity' }, label: 'customization.identity', description: 'customization.identity_description', icon: 'school' },
        { key: 'design', to: { name: 'academy.design' }, label: 'customization.design', description: 'customization.design_description', icon: 'swatchbook' },
        { key: 'home', to: { name: 'academy.home' }, label: 'customization.home', description: 'customization.home_description', icon: 'home' },
        { key: 'menu', to: { name: 'academy.menu' }, label: 'customization.menu', description: 'customization.menu_section_description', icon: 'list-ul' },
        { key: 'contact', to: { name: 'academy.contact' }, label: 'customization.contact_social', description: 'customization.contact_description', icon: 'id-card-alt' },
        { key: 'legal', to: { name: 'academy.legal' }, label: 'customization.legal', description: 'customization.legal_description', icon: 'file-contract' },
        // Ajustes tiene subpantallas: sigue activa en todas ellas.
        {
          key: 'settings',
          to: { name: 'academy.domain' },
          label: 'customization.settings',
          description: 'customization.settings_description',
          icon: 'cogs',
          activeNames: ['academy.domain', 'academy.lang', 'academy.scripts'],
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>
